module.exports = __webpack_public_path__ + "static/media/slideMobile01.40776b25.jpg";